import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Box, Button, Chip, Divider, Stack, Tooltip, Typography } from '@mui/material';
import styles from './LicenceItem.module.css';
import { AccessTime, AccountCircle, AppsOutlined, CalendarMonth, ExpandMore, FileDownload, HideSource, RemoveCircle, ShoppingBagOutlined } from '@mui/icons-material';
import { ConfirmationDialog } from 'components/dialogs';
import { useState } from 'react';
import { isoToDateString, monthEnding } from 'utils/date';

const LicenceItem = ({item, expanded, expandedBar,selectLicence, onEdit}) => {
  const [openBlockDialog, setOpenBlockDialog] = useState(false);
  const [openSendDialog, setOpenSendDialog] = useState(false);
  const renderApp = (item) => {
    return (
      <Box px={1} sx={{display: 'flex', alignItems: 'center'}}>
        <AppsOutlined/>
        <Box ml={1} sx={{display: 'flex', flexDirection: 'column'}}>
          <Typography align='center'>{item.subject.at(0).name}</Typography>
          <Typography variant="caption">{item.subject.at(0).package}</Typography>
        </Box>
      </Box>
    );
  };

  const renderProfile = (item) => {
    return (
      <Box px={1} sx={{display: 'flex', alignItems: 'center'}}>
        <ShoppingBagOutlined sx={{mx: 1}}/>{item.subject.at(0).name}
      </Box>
    );
  };

  const renderSubject = (item) => {
    return (
      <div className={styles.subject}>{item.subjectType === 'app' ? renderApp(item) : renderProfile(item)}</div>
    );
  };

  const renderActiveTo = (item) => {
    return <Tooltip title="Дата окончания лицензии">
            <Chip icon={<AccessTime fontSize='small'/>} label={isoToDateString(item.activeTo)} sx={{marginLeft: 'auto'}}/>
          </Tooltip>;
  };

  const renderUsed = (item) => {
    return (
      <>
      <Divider orientation="vertical" flexItem />
      <Stack direction="row" spacing={1} alignItems="flex-end">
        <FileDownload fontSize="small" color='secondary'/>
        <Tooltip title="Дата загрузки лицензии в кассу">
          <Typography variant="caption" sx={{lineHeight: "1.2rem"}}>Загружена {isoToDateString(item.usedAt)}</Typography>
        </Tooltip>  
      </Stack>
      </>
    );
  };

  const blockHandler = (e) => {
    onEdit({id:item.id, body: {isBlock: !item.isBlock}});
    setOpenBlockDialog(false);
  };

  const sendHandler = (params) => {
    onEdit({id: item.id, query: params, body: {isUse: true}});
    setOpenSendDialog(false);
  };
 
  const cancelBlockHandler = (e) => {
    setOpenBlockDialog(false);
  };

  const cancelSendHandler = (e) => {
    setOpenSendDialog(false);
  };

  return (
    <Accordion 
      onChange={selectLicence(item.id)}
      key={`${item.id}-${expandedBar}`}
      {...(
        expandedBar === 'collapsed' ? {expanded: (expanded === item.id)} : {defaultExpanded: true}
      )}
    >
      <AccordionSummary id={item.id} expandIcon={<ExpandMore/>}
        className={`${item.isBlock ? styles.blocked : styles.noBlocked} ${item.isUse ? styles.used : styles.noUsed}`} 
      >
        <Stack direction='row' alignItems='center' justifyContent='center' sx={{width: '100%'}}>
          <Box className={styles.columnSummary} sx={{justifyContent: 'start'}}>
            <Typography 
              sx={{px:1}}
              onClick={(e)=>e.stopPropagation()}
              >
                <span className={styles.key}>{item.key}</span>
            </Typography>
          </Box>
          <Box className={styles.columnSummary} sx={{justifyContent: 'center'}}>
            <div className={item.isEnd ? styles.end : styles.duration}>{item.isEnd ? 'закончилась' : (item.duration + ` ${monthEnding(item.duration)}`) }</div>
          </Box>
          <Box className={styles.columnSummary} sx={{justifyContent: 'end'}}>
            <Box align='right'>{renderSubject(item)}</Box>
          </Box>
        </Stack>
      </AccordionSummary>
      <AccordionDetails  className={item.isUse ? styles.used : styles.noUsed}>
        <Stack direction="row"  alignItems="center" sx={{minHeight: "32px"}}>
          <Typography  align='center' sx={{position: 'absolute', left: '50%', transform: 'translateX(-50%)'}}>{item.status}</Typography>
          {item.isActivate ? renderActiveTo(item) : null}
        </Stack>
        <Stack className={styles.date} direction="row" justifyContent="center" spacing={2} mt={1}>
          <Stack direction="row" spacing={1}>
            <CalendarMonth fontSize="small" color='secondary'/>
            <Typography variant="caption" sx={{lineHeight: "1.2rem"}}>Создана {isoToDateString(item.createdAt)}</Typography>
          </Stack>
          <Divider orientation="vertical" flexItem />
          <Stack direction="row" spacing={1} alignItems="flex-end">
            <AccountCircle fontSize="small"  color='secondary'/>
            <Tooltip title="Создал пользователь">
              <Typography variant="caption" sx={{lineHeight: "1.2rem"}}>{item.createdBy}</Typography>
            </Tooltip>
          </Stack>
          {item.isUse ? renderUsed(item) : null}
          <Divider orientation="vertical" flexItem />
          <Stack direction="row" spacing={1} alignItems="flex-end">
            <AccessTime fontSize="small" color='secondary'/>
            <Typography variant="caption" sx={{lineHeight: "1.2rem"}}>
              {item.isActivate ? `Активирована ${isoToDateString(item.activatedAt)}` : `Активация до ${isoToDateString(item.endActivationAt)}`}  
            </Typography>
          </Stack>
        </Stack>
      </AccordionDetails>
      <Divider/>
      <AccordionActions>
        <Button 
          disabled={item.isUse} 
          startIcon={<FileDownload/>}
          onClick={() => setOpenSendDialog(true)}
        >
          На кассу
        </Button>
        <Button 
          startIcon={item.isBlock ? <HideSource/> : <RemoveCircle/>} 
          color="error"
          onClick={() => setOpenBlockDialog(true)}
        >
            {item.isBlock ? "Разблокировать" : "Заблокировать"}
        </Button>
        <ConfirmationDialog 
          title='Отправить лицензию на кассу'
          text={<span>Отправить лицензию <b>{item.key}</b> на кассу?</span>}
          promptText="Заводской номер кассы"
          open={openSendDialog}
          onOk={sendHandler}
          onCancel={cancelSendHandler}
          inputs={[
            {label: 'Номер кассы', id: 'factoryNumber', required: true, focus: true}
          ]}
        />
        <ConfirmationDialog 
          title={item.isBlock ? 'Разблокировать' : 'Заблокировать'}
          text={<span>{item.isBlock ? 'Разблокировать' : 'Заблокировать'} лицензию <b>{item.key}</b>?</span>}
          open={openBlockDialog}
          onOk={blockHandler}
          onCancel={cancelBlockHandler}
        />
      </AccordionActions>
    </Accordion>
  );
};

export default LicenceItem;